import { Input, Search } from '@core/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ParticipantListSearch = ({ onSearchChange }: { onSearchChange: (search: string) => void }) => {
    const { t } = useTranslation();
    const [search, setSearch] = useState<string>('');

    // Debounce the search input to avoid too many calls
    useEffect(() => {
        const handle = setTimeout(() => {
            onSearchChange(search);
        }, 150);

        return () => {
            clearTimeout(handle);
        };
    }, [search]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    };

    return (
        <Input label={t('Participants.Search.Label')} value={search} onChange={onChange} classNames="mb-4 px-2" hasIcon>
            <Search classNames="absolute bottom-2.5 left-4 w-6 h-6 opacity-75 pointer-events-none stroke-current" />
        </Input>
    );
};
